import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ComponentsModule } from '../shared/components/components.module';

import { ProverbRoutingModule } from './proverb-routing.module';

import { ProverbComponent } from './proverb.component';


@NgModule({
  declarations: [
    ProverbComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ComponentsModule,
    ProverbRoutingModule,
  ]
})
export class ProverbModule { }
